module.exports = __webpack_public_path__ + "static/media/icon.7cbafe70.svg";